module.exports = __webpack_public_path__ + "static/x5c-ae1bfd0a64cf1485a2d8ab89229ca465.png";